define.alias("checkout/components/input-stepper", "settings/components/input-stepper");